import { render, staticRenderFns } from "./45-1.vue?vue&type=template&id=acdf943e&scoped=true&"
import script from "./45-1.vue?vue&type=script&lang=js&"
export * from "./45-1.vue?vue&type=script&lang=js&"
import style0 from "./45-1.vue?vue&type=style&index=0&id=acdf943e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acdf943e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/dgq/mei_bao_pro/insuranceagent-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('acdf943e')) {
      api.createRecord('acdf943e', component.options)
    } else {
      api.reload('acdf943e', component.options)
    }
    module.hot.accept("./45-1.vue?vue&type=template&id=acdf943e&scoped=true&", function () {
      api.rerender('acdf943e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/insurance/product/details/45-1.vue"
export default component.exports